import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { AppStateType } from 'reducers';
import { signOut } from 'thunk';

const SecurityLayer = ({ children }: { children: any }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state: AppStateType) => state.authReducer.user);

  const shouldNotMoveToNextLayer = !user?.account;

  useEffect(() => {
    if (shouldNotMoveToNextLayer) {
      dispatch(signOut());
    }
  }, [dispatch, shouldNotMoveToNextLayer]);
  /**
   * This condition is only checking whether
   * this user is a super admin in their own default team
   * For accuracy, recommend BE to send a flag to indicate
   * if this user is a super admin when calling `/me`
   */
  if (shouldNotMoveToNextLayer) {
    return (
      <div>You don&apos;t have permission to access Galaxy. Redirecting to login screen...</div>
    );
  }

  return <div>{children}</div>;
};

export default SecurityLayer;
